export {
  CHINA_MAP_LABEL_FONT_SIZE,
  CHINA_MAP_LABEL_GLYPH_HALF_SIZE,
  getChinaMapLabelLineOffsets,
  getChinaMapLabelOffsetUnit,
  type ChinaMapLabelLayout,
} from "#china-map-label-box";
export {
  CHINA_MAP_REGION_IDS,
  CHINA_MAP_TRADITIONAL_LABEL_REGION_IDS,
  isChinaMapTraditionalLabelRegion,
  type ChinaMapRegionId,
  type ChinaMapTraditionalLabelRegionId,
} from "#china-map-regions";
export type {
  ChinaMap,
  ChinaMapPlace,
  ChinaMapProvince,
  ChinaPlaceCategory,
} from "#china-map-types";
export { parseChinaPlaceName } from "#parse-china-place-name";
